export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "recentOrderTray__reviewsCleared--title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You Are a Reviewing Machine!"])},
        "recentOrderTray__reviewsCleared--subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Thank you for the feedback on your items—you've already made Nuuly better for everyone."])},
        "recentOrderTray__reviewsCleared--CTA": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View Rental History"])}
      }
    }
  })
}
